import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 1001;
  transition: all 0.4s;
  background: var(--black-2);
  color: var(--white-darker);
  padding-top: 40px;

  > div {
    > h1 {
      font-size: 24px;
      font-weight: 600;
    }

    > p {
      font-size: 14px;
    }
  }

  > canvas {
    background: var(--gray-e);
    width: 300px !important;
    height: auto !important;

    @media (max-width: 800px) {
      width: 100% !important;
      height: auto !important;
    }
  }

  > section {
    display: flex;
    flex-direction: column;
    background: var(--black-2);
    padding: 32px;
    border-radius: 16px 16px 0 0;

    @media (max-width: 800px) {
      width: 100%;
    }
  }
`;

export const Slider = styled.div`
  display: grid;
  grid-template-columns: 20px 1fr;
  place-items: center;
  gap: 16px;

  background: var(--black-2);
  border-radius: 16px;
  padding: 8px 16px;
  margin-bottom: 8px;
  width: 345px;

  @media (max-width: 800px) {
    width: 100%;
  }

  > input {
    -webkit-appearance: none;
    width: 100%;
    height: 4px;
    border-radius: 4px;
    background: var(--black-7);
    outline: none;
    opacity: 0.7;
    padding: 0;
    -webkit-transition: 0.2s;
    transition: all 0.2s ease;
    border: 0;

    ::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 16px;
      height: 16px;
      background: var(--info);
      border-radius: 50%;
      cursor: pointer;
    }
  }
`;

export const ButtonRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: center;
  margin-top: 16px;

  > button {
    height: 50px;
    border-radius: 16px;
    padding: 16px 32px;
    background: var(--black-3);
    color: var(--white-darker);
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  > button:last-child {
    background: var(--primary);
  }
`;
